export const messages = {
  zh: {
    wirteRuleFeeRemark: {
      title: '费用备注',
      remark: '备注',
      remarkPlaceholder: '必填，请填写备注',
      remarkRequired: '请填写备注'
    },
  },
   en: {
    wirteRuleFeeRemark: {
      title: 'Fee Remark',
      remark: 'Remark',
      remarkPlaceholder: 'Required, please fill in the remark',
      remarkRequired: 'Please fill in the remark'
    },
  },
  'zh-TW': {
    wirteRuleFeeRemark: {
      title: '費用備註',
      remark: '備註',
      remarkPlaceholder: '必填，請填寫備註',
      remarkRequired: '請填寫備註'
    },
  }
}